import config from './config/config.json';

export const apiUrl = config.apiUrl    // Url API
export const sitekey = config.sitekey  // Site Key re-capcha
